import gsap from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';

export default class Preloader {
    _container;
    _progress;
    _isShow = false;
    _isHide = false;
    _call = null;

    static init() {
        this._container = GetBy.id('Preloader');
        this.logo = GetBy.class('logo', this._container)[0];

        gsap.to(this.logo, {
            duration: .5,
            opacity: 1,
            delay: .1,
            ease: "power2.inOut", 
            onComplete: () => {
                this._isShow = true;

                if(this._isHide) {
                    this.hide(this._call);
                };
            }
        });

        if (isDebug) {
            this._container.style.display = "none";
            return;
        }
    }

    static update(__progress) {
        if (isDebug) return;
    }

    static hide(__call) {
        this._isHide = true;
        this._call = __call;

        if (!this._isShow) return;

        if (isDebug) {
            if (__call) __call();
            return;
        }

        gsap.to(this.logo, {
            duration: .4,
            opacity: 0,
            delay: .3,
            ease: "power2.in",
            onComplete: () => {
                if (__call) __call();
            }
        });
        
        gsap.to(this._container, {
            duration: .2,
            opacity: 0,
            delay: .7,
            ease: "power2.in",
            onComplete: () => {
                this._container.style.display = "none";
            }
        });
    }
}
